import { Injectable } from '@angular/core';
import { LogService } from './log.service';
import { SessionStorageService } from './session-storage.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable, of } from 'rxjs';
import { OverlayRecord } from '../types/overlay/overlay-record';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class OverlayService {
  private api = environment.api;

  constructor(
    private log: LogService,
    private storageService: SessionStorageService,
    private http: HttpClient
  ) {
  }

  getOverlays(countToLoad: number, fromDate: string, toDate: string, programs: string): Observable<OverlayRecord[]> {
    this.log.trace('OverlayService.getOverlays.url', this.api.overlayList);
    return this.http.post<any>(this.api.overlayList, {
      uuxSessionId: this.storageService.getUUXSessionId(),
      maxRecordCount: countToLoad,
      fromDate: fromDate,
      toDate: toDate,
      programs: programs
    }).pipe(
      map(response => {
        this.log.trace('OverlayService.getOverlays.response', response);
        return response.list;
      })
    );
  }

  ignoreRecords(overlays: any[]): Observable<any> {
    const payload = {
      Overlays: overlays,
      uuxSessionId: this.storageService.getUUXSessionId()
    };
    this.log.trace('OverlayService.ignoreRecords.url', this.api.overlayIgnore);
    return this.http.post<any>(this.api.overlayIgnore, payload);
  }

  acceptRecords(overlays: any[]): Observable<any> {
    const payload = {
      Overlays: overlays,
      uuxSessionId: this.storageService.getUUXSessionId()
    };
    this.log.trace('OverlayService.acceptRecords.url', this.api.overlayAccept);
    return this.http.post<any>(this.api.overlayAccept, payload);
  }

  getUrl(baseUrl: string, params?: any) {
    if (!params) {
      return baseUrl;
    }
    else {
      return baseUrl + '?' + this.encodeData(params);
    }
  }

  private encodeData(data: any): string {
    return Object.keys(data)
      .map(key => {
        return [key, data[key]].map(encodeURIComponent).join('=');
      })
      .join('&');
  }
}
